import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logoutUser } from "../actions/authActions";
import { FaBars, FaTimes } from "react-icons/fa";

const AccountSidebar = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // Check screen size
  useEffect(() => {
    const checkScreenSize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      if (!mobile) {
        setIsMobileMenuOpen(false);
      }
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);

    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  const handleLogout = () => {
    dispatch(logoutUser(navigate));
  };

  const navigateToMyAccount = (section) => {
    navigate("/myaccount", { state: { section } });
    if (isMobile) {
      setIsMobileMenuOpen(false);
    }
  };

  const handleMenuClick = (callback) => {
    if (typeof callback === "function") {
      callback();
    }
    if (isMobile) {
      setIsMobileMenuOpen(false);
    }
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <>
      {/* Mobile Menu Toggle Button */}
      {isMobile && (
        <button
          className="mobile-menu-toggle"
          onClick={toggleMobileMenu}
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
          <span className="menu-text">
            {isMobileMenuOpen ? "Close Account Menu" : "Account Menu"}
          </span>
        </button>
      )}

      {/* Mobile Overlay */}
      {isMobile && isMobileMenuOpen && (
        <div
          className="mobile-menu-overlay"
          onClick={() => setIsMobileMenuOpen(false)}
        ></div>
      )}

      {/* Sidebar */}
      <div
        className={`myaccount-sidebar ${isMobile ? "mobile" : ""} ${
          isMobileMenuOpen ? "open" : ""
        }`}
      >
        <div className="myaccount-menu-section">
          <h3>My Shopping</h3>
          <ul>
            <li onClick={() => handleMenuClick(() => navigate("/orders"))}>
              Track Orders
            </li>
            <li
              onClick={() =>
                handleMenuClick(() => navigateToMyAccount("cancellation"))
              }
            >
              Cancellation History
            </li>
            <li onClick={() => handleMenuClick(() => navigate("/cart"))}>
              Cart
            </li>
            <li
              onClick={() =>
                handleMenuClick(() => navigateToMyAccount("wishlist"))
              }
            >
              Wish List
            </li>
          </ul>
        </div>
        <div className="myaccount-menu-section">
          <h3>My Activities</h3>
          <ul>
            <li onClick={() => handleMenuClick(() => navigate("/contactus"))}>
              Contact Us
            </li>
            <li
              onClick={() =>
                handleMenuClick(() => navigateToMyAccount("reviews"))
              }
            >
              Reviews
            </li>
          </ul>
        </div>
        <div className="myaccount-menu-section">
          <h3>My Profile</h3>
          <ul>
            <li onClick={() => handleMenuClick(() => navigate("/accountinfo"))}>
              Account Information
            </li>
            <li
              onClick={() =>
                handleMenuClick(() => navigateToMyAccount("beauty-profile"))
              }
            >
              Beauty Profile
            </li>
            <li
              onClick={() =>
                handleMenuClick(() => navigateToMyAccount("addresses"))
              }
            >
              Addresses
            </li>
            <li
              onClick={() =>
                handleMenuClick(() => navigateToMyAccount("login-history"))
              }
            >
              Login History
            </li>
            <li
              onClick={() =>
                handleMenuClick(() => navigateToMyAccount("deactivate"))
              }
            >
              Deactivate Account
            </li>
          </ul>
        </div>
        <button
          onClick={handleLogout}
          className="myaccount-track-orders-button"
        >
          Logout
        </button>
      </div>
    </>
  );
};

export default AccountSidebar;
